<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-ensino-medio')" class="main bg-white" id="about-main">
      <b-container id="center-y w-100">
        <b-card class="bg-transparent border-0">
          <b-row class="mb-5">
            <b-col cols="12" md="6" lg="4" v-for="(list, index) in lists" :key="index">
              <router-link :to="`${list.link_name}`">
                <b-card no-body :style="list.colorCard" :class="list.bg__link" class="card-link shadow-sm border-0">
                  <h5 class="text-uppercase font-weight-bold text-center text-white mt-3">{{ list.title }}</h5>
                  <p class="text-center text-white">{{ list.text }}</p>
                  <div class="corner d-none d-md-none d-lg-flex">
                    <div class="arrow">
                      <i class="fa-solid fa-arrow-right"></i>
                    </div>
                  </div>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
require('baguettebox.js/dist/baguetteBox.min.css');

export default {
  name: 'ensino-fundamental-1-caderno-digital',
  metaInfo: {
    title: 'COLEÇÃO CPV',
  },
  props: {},

  data() {
    return {
      NamePermission: '',
      IndexPermission: '',
      pageTitle: 'ENSINO MÉDIO',
      pageSubtitle: 'MANUAL',

      Deselect: {
        render: (createElement) => createElement('span', ''),
      },

      title2: '',
      nome_arquivo: '',

      selected: null,

      filterOption: 'Todos',
      MySearch: '',
      SearchTitle: '',
      SearchDiscipline: '',
      SearchSegment: '',
      SearchBundle: '',

      lists: [
        {
          title: 'Química',
          text: '',
          link_name: 'ensino-medio-aula-digital-quimica',
          iconClass: '',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
            color: '#ffffff',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'infantil',
          // childSlug: 'infantil-2-maternal-i'
        },
        {
          title: 'Biologia',
          text: '',
          link_name: 'ensino-medio-aula-digital-biologia',
          iconClass: '',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'fundamental-i',
          // childSlug: 'infantil-3-maternal-ii'
        },
        {
          title: 'Física',
          text: '',
          link_name: 'ensino-medio-aula-digital-fisica',
          iconClass: '',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'fundamental-ii',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: 'Geografia',
          text: '',
          link_name: 'ensino-medio-aula-digital-geografia',
          iconClass: '',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'medio',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: 'História',
          text: '',
          link_name: 'ensino-medio-aula-digital-historia',
          iconClass: '',
          colorCard: {
            'background-color': '#f7b03d',
            'border:': '1px solid #f7b03d',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'enem',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: 'Língua Portuguesa',
          text: '',
          link_name: 'ensino-medio-aula-digital-lp',
          iconClass: '',
          colorCard: {
            'background-color': '#fa6d9e',
            'border:': '1px solid #fa6d9e',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'pre-vestibular',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: 'Líteratura',
          text: '',
          link_name: 'ensino-medio-aula-digital-literatura',
          iconClass: '',
          colorCard: {
            'background-color': '#3b1953',
            'border:': '1px solid #3b1953',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'banco-questoes',
          // childSlug: 'infantil-4-jardim-i'
        },
        {
          title: 'Matemática',
          text: '',
          link_name: 'ensino-medio-aula-digital-matematica',
          iconClass: '',
          colorCard: {
            'background-color': '#2873BE',
            'border:': '1px solid #2873BE',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'banco-livros',
          // childSlug: 'infantil-4-jardim-i'
        },
        // {
        //   title: 'Programação Ensino Médio: Base',
        //   text: '',
        //   link_name: 'ensino-medio-aula-digital-matematica',
        //   iconClass: '',
        //   colorCard: {
        //     'background-color': '#a7dc48',
        //     'border:': '1px solid #a7dc48',
        //     'border-radius': '0.5rem',
        //   },
        //   permission: 'segmento-ensino-medio',
        //   bg__link: 'fundamental-ii',
        //   // childSlug: 'infantil-4-jardim-i'
        // },
        {
          title: 'Redação',
          text: '',
          link_name: 'ensino-medio-aula-digital-redacao',
          iconClass: '',
          colorCard: {
            'background-color': '#F6A07A',
            'border:': '1px solid #F6A07A',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'assessoria',
          // childSlug: 'infantil-4-jardim-i'
        },

      ],
    };
  },
  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },
  computed: {
    filterHead() {
      return this.list.filter((ret) => {
        return (
          ret.title.match(this.SearchTitle) &&
          ret.bundle.match(this.SearchBundle.value) &&
          ret.discipline.match(this.SearchDiscipline) &&
          ret.segment.match(this.SearchSegment.value)
        );
      });
    },
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    onComplete: function () {
      this.$router.push({
        name: 'pdf-read-only',
        params: {
          nome_arquivo: this.nome_arquivo,
          title2: this.title2,
        },
      });
    },

    reload() {
      location.reload();
    },

    resetOptions: function () {
      (this.SearchBundle = ''),
        (this.SearchTitle = ''),
        (this.SearchDiscipline = ''),
        (this.SearchSegment.name = ''),
        this.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.bread__sistema {
  margin-top: -32px;
}

#center-y {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (min-width: 80rem) {
  #center-y {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media only screen and (min-width: 62rem) and (max-width: 80rem) {
  #center-y {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-bottom: 50px;
  }
}

@media only screen and (min-width: 48rem) and (max-width: 62rem) {
  .main {
    margin-top: -55px;
  }

  #center-y {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-bottom: 50px;
  }
}

@media only screen and (min-width: 36rem) and (max-width: 48rem) {
  .main {
    margin-top: -55px;
  }

  #center-y {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-bottom: 50px;
    margin-top: -15px;
  }
}

@media only screen and (min-width: 20rem) and (max-width: 36rem) {
  .header__sistema {
    margin-top: -55px;
  }

  .bread__sistema {
    margin-top: -35px;
  }

  #center-y {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-bottom: 50px;
    margin-top: -15px;
  }
}
</style>
